/* eslint-disable */
import { Avatar, Link, makeStyles } from "@material-ui/core";
import { Options, Column } from "material-table";
import React from "react";
import { toImageUrl } from "../../../../utils/formatHelper";
import { toAbsoluteUrl } from "../../../../_metronic/_helpers";

export const useStylesSetting = makeStyles(theme => ({
    boxContentFixed: {
        // height: 600
    },
    itemDD: {
        padding: ".75rem 1rem",
        backgroundColor: "#0000",
        boxShadow: "0 1px 0 0 #efefefa0",
        maxWidth: "100%",
        overflow: "hidden",
        whiteSpace: "pre-line",
    },
    btnAcStatus: {
        background: "#efefef",
        color: "#bbb",
        fontSize: 22,
        fontWeight: 600,
        width: "100%",
        marginBottom: 15,
        transition: "all .25s",
        "&.active": {
            background: "linear-gradient(90deg, #00B0E1 0%, #9DDDFC 100%)",
            color: "#fff",
        },
    },
    titleCard: {
        color: "#fff",
        textAlign: "center",
        background: "linear-gradient(90deg, #00B0E1 0%, #9DDDFC 100%)",
        height: "15%",
        fontSize: 18,
        fontWeight: 600,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
    },
    boxListUserWait: {
        height: "85%",
        overflowY: "auto",
    },
    boxlistRoom: {
        height: 40,
        textAlign: "center",
        padding: "1.25rem",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "pointer",
        background: "linear-gradient(90deg, #CFD9DF 0%, #E2EBF0 100%)",
        color: "#fff",
        transition: "all .15s",
        borderTopRightRadius: 5,
        borderTopLeftRadius: 5,
        transform: "translateY(7px)",
        "&:hover": {
            opacity: 0.75,
        },
        "&.active": {
            background: "linear-gradient(90deg, #00B0E1 0%, #9DDDFC 100%)",
            color: "#fff",
            borderTop: "2px solid #1648CE",
            pointerEvents: "none",
            transform: "translateY(0px)",
        },
        "& .text-typo": {
            marginBottom: 0,
            fontWeight: 600,
        },
    },
}));

/** @type Options */
export const initialTableOptions = {
    pageSize: 5,
    pageSizeOptions: [5, 10, 20, 50],
    actionsColumnIndex: -1,
    emptyRowsWhenPaging: false,
    headerStyle: {
        fontSize: 15,
    },
    debounceInterval: 500,
    // have not affect table
    totalData: 0,
    order: "",
    direction: "",
};

/** @type Options */
export const initialTableOptionsSocial = {
    search: false,
    showTitle: false,
    paginationType: "stepped",
    pageSize: 5,
    pageSizeOptions: [5, 10, 20, 50],
    actionsColumnIndex: -1,
    emptyRowsWhenPaging: false,
    headerStyle: {
        fontSize: 15,
    },
    debounceInterval: 500,
    // have not affect table
    totalData: 0,
    order: "",
    direction: "",
};

export const columnsTableSocial = props => {
    /** @type Column */
    const array_columns = [
        {
            title: "Icon",
            field: "icon",
            sorting: false,
            render: rowData => {
                const path = rowData?.icon;
                return (
                    <Avatar
                        variant="rounded"
                        alt={"imge_icon"}
                        src={
                            rowData?.icon
                                ? path !== "https"
                                    ? toImageUrl(rowData?.icon)
                                    : rowData?.icon
                                : toAbsoluteUrl("/media/HCH/users/empty_img.png")
                        }
                    />
                );
            },
        },
        {
            field: "name",
            title: "Title",
            render: rowData => {
                const title = rowData?.name;
                return <p className="mb-0">{title}</p>;
            },
        },
        {
            field: "link",
            title: "Link",
            render: rowData => {
                const link = rowData?.link;
                return (
                    <Link href={link} target="_blank">
                        {link}
                    </Link>
                );
            },
        },
    ];
    return array_columns;
};
